import BlogThirtyFourContainer from "./container/BlogThirtyFourContainer";
export default BlogThirtyFourContainer;
